const ALL_VIDEOS = [
  {
    id: 1,
    en: { title: 'How to create projects', duration: '2:35', youtubeId: 'kfZqfuoFSbs' },
    de: { title: 'Projekte erstellen', duration: '2:31', youtubeId: 'aXiX64pPrFM' },
    fr: { title: 'Comment créer des projets', duration: '2:31', youtubeId: '77TLWkhneoI' },
    kr: { title: '프로젝트를 생성하는 방법', duration: '2:31', youtubeId: 'fF1ivtA2yT8' },
    pt: { title: 'Como criar projetos', duration: '2:31', youtubeId: 'O5QDMOwNKHU' },
    es: { title: 'Cómo crear proyectos', duration: '2:31', youtubeId: 'Qow4j9oQwow' },
  },
  {
    id: 2,
    en: { title: 'How to structure your tasks', duration: '2:13', youtubeId: 'oHvYxFjI0B0' },
    de: { title: 'Aufgaben strukturieren', duration: '2:13', youtubeId: 'waAJUfWqiW0' },
    kr: { title: '작업을 구성하는 방법', duration: '2:12', youtubeId: 'sNv2_gOqktc' },
    pt: { title: 'Como estruturar suas tarefas', duration: '2:14', youtubeId: 'M5-maZcpGLo' },
    es: { title: 'Cómo estructurar tus tareas', duration: '2:13', youtubeId: 'lltkRNHzx5s' },
  },
  {
    id: 3,
    en: { title: 'How to work with custom fields', duration: '2:10', youtubeId: 'abVoAdzQPkA' },
  },
  {
    id: 4,
    en: { title: 'How to manage custom fields at the account level', duration: '2:07', youtubeId: 'EnlCWAUfzGc' },
    de: { title: 'Benutzerdefinierte Felder auf Kontoebene verwalten', duration: '2:04', youtubeId: 'agJ-KnnQvU0' },
    fr: {
      title: 'Comment gérer les champs personnalisés au niveau du compte',
      duration: '2:04',
      youtubeId: 'kyOMmjKiQkE',
    },
    kr: { title: '계정 수준에서 사용자 정의 필드를 관리하는 방법', duration: '2:04', youtubeId: 'SJBtNJxTSxk' },
    pt: { title: 'Como gerenciar campos personalizados no nível da conta', duration: '2:06', youtubeId: 'ndlErp4CzGk' },
    es: { title: 'Cómo gestionar campos personalizados a nivel de cuenta', duration: '2:04', youtubeId: 'KpKj-5H4hII' },
  },
  {
    id: 5,
    en: { title: 'How to share projects with third parties', duration: '1:22', youtubeId: 'gE8kA_Lw-lU' },
    de: { title: 'Projekte extern teilen', duration: '1:21', youtubeId: 'dRKR9mjetWc' },
    kr: { title: '프로젝트를 제3자와 공유하는 방법', duration: '1:21', youtubeId: 'cfA9LdGSKjE' },
    pt: { title: 'Como compartilhar projetos com terceiros', duration: '1:21', youtubeId: 'SBrP1Gp_S6w' },
    es: { title: 'Cómo compartir proyectos con terceros', duration: '1:21', youtubeId: 'JklLSvt9Zvs' },
  },
  {
    id: 6,
    en: { title: 'How to invite team members to account and projects', duration: '1:50', youtubeId: 'SZTLPUvZm_0' },
    de: { title: 'Teammitglieder zu Konto und Projekten einladen', duration: '1:50', youtubeId: 'Hskp6OPUFbQ' },
    kr: { title: '계정 및 프로젝트에 팀원을 초대하는 방법', duration: '1:50', youtubeId: '1PS0sbnn-lM' },
    pt: {
      title: 'Como convidar membros da equipe para a conta e os projetos',
      duration: '1:50',
      youtubeId: '40qAq6OMZzg',
    },
    es: {
      title: 'Cómo invitar a miembros del equipo a la cuenta y a los proyectos',
      duration: '1:50',
      youtubeId: 'uWVKb9YQ35U',
    },
  },
  {
    id: 7,
    en: { title: 'How to add new users to account', duration: '1:15', youtubeId: 'NISbawxJ-4U' },
    de: { title: 'Neue Benutzer zum Konto hinzufügen', duration: '1:15', youtubeId: 'tbJX_mU_6QE' },
    kr: { title: '계정에 새 사용자를 추가하는 방법', duration: '1:15', youtubeId: 'DjlfbTfU0wM' },
    pt: { title: 'Como adicionar novos usuários à conta', duration: '1:15', youtubeId: 'zvXTFdfneZw' },
    es: { title: 'Cómo agregar nuevos usuarios a la cuenta', duration: '1:15', youtubeId: 'zvXTFdfneZw' },
  },
];

export const getVideoTutorials = (locale = 'en') => {
  return ALL_VIDEOS.map((video) => {
    const videoData = video[locale] || video.en;

    return {
      id: video.id,
      title: videoData.title,
      duration: `${videoData.duration} min`,
      youtubeId: videoData.youtubeId,
      thumbnail: `https://img.youtube.com/vi/${videoData.youtubeId}/maxresdefault.jpg`,
    };
  });
};

// export const VIDEO_TUTORIALS = getVideoTutorials(window.user?.locale || 'en');
